import Emitter from "../../helpers/emitter"
import * as emits from "../../constants/emits"

export default class CovidQAModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.elem.modalQuestionsJson = elem.dataset.modalQuestions && JSON.parse(elem.dataset.modalQuestions)
    self.elem.modalAnswers = elem.dataset.modalAnswers && JSON.parse(elem.dataset.modalAnswers)
    self.elem.language = elem.dataset.language && JSON.parse(elem.dataset.language)
    self.elem.dateLabel = elem.dataset.dateLabel && JSON.parse(elem.dataset.dateLabel)
    self.init()
    return self
  }

  init() {
    const self = this
    self.addEventListeners()
  }

  addEventListeners() {
    const self = this
    if (self.elem) {
      self.elem.addEventListener("click", (e) => this.handleClickLink(e))
    }
  }

  handleClickLink(e) {
    const self = this
    if (self.elem.modalQuestionsJson && self.elem.modalAnswers) {
      e.preventDefault()
      Emitter.emit("*", {
        type: emits.REQUEST_QA_MODAL_OPEN,
        modalQuestionsJson: self.elem.modalQuestionsJson,
        modalAnswers: self.elem.modalAnswers,
        language: self.elem.language,
        dateLabel: self.elem.dateLabel,
      })
    }
  }
}
